import { jwtDecode } from 'jwt-decode';

export function tokenDecoder(token) {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch {
    return `Invalid Token: ${token}`;
  }
}
